import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';
import { Iterable, List } from 'immutable';
import { Row, Col, FormGroup, FormControl } from 'react-bootstrap';

import JobActions from '../../actions/JobActions';

const listFromSelectValues = selectVals => new List(selectVals).map(x => x.value);

const JOB_STATUS_OPTIONS = [
  { value: 'submitted', label: 'Submitted' },
  { value: 'pending', label: 'Pending' },
  { value: 'running', label: 'Running' },
  { value: 'finished', label: 'Finished' },
  { value: 'failed', label: 'Failed' },
  { value: 'killed', label: 'Killed' },
];

const JobFilter = ({ filters, updateFilter, allOwners }) => {
  const onUpdateNameSearch = (e) => {
    updateFilter('nameSearch', e.target.value);
    JobActions.debouncedLoadAllJobs();
  };

  const onUpdateOwnerFilter = (vals) => {
    updateFilter('allowedOwners', listFromSelectValues(vals));
    JobActions.debouncedLoadAllJobs();
  };

  const onUpdateStatusFilter = (vals) => {
    updateFilter('allowedStatuses', listFromSelectValues(vals));
    JobActions.debouncedLoadAllJobs();
  };

  return (
    <Row>
      <Col md={2}>
        <Select
          onChange={onUpdateStatusFilter}
          options={JOB_STATUS_OPTIONS}
          value={filters.allowedStatuses.toJS()}
          multi
          autoBlur
          placeholder='STATUS'
        />
      </Col>
      <Col md={4}>
        <Select
          onChange={onUpdateOwnerFilter}
          options={allOwners.toJS()}
          value={filters.allowedOwners.toJS()}
          multi
          autoBlur
          placeholder='OWNER'
        />
      </Col>
      <Col md={6}>
        <FormGroup>
          <FormControl
            type='text'
            placeholder='SEARCH JOBS'
            value={filters.nameSearch}
            onChange={onUpdateNameSearch}
          />
        </FormGroup>
      </Col>
    </Row>
  );
};

export default JobFilter;

JobFilter.propTypes = {
  allOwners: PropTypes.instanceOf(Iterable),
  filters: PropTypes.shape({
    nameSearch: PropTypes.string,
    allowedStatuses: PropTypes.instanceOf(Iterable),
    allowedOwners: PropTypes.instanceOf(Iterable),
  }),
  updateFilter: PropTypes.func,
};
